import React from "react";
import { Text, Flex, Button } from "@chakra-ui/react";

// Constants
import { LEARN_MORE_URL } from "constants/constants";
import { LEARN_MORE } from "constants/analytics";

// Hooks
import useApp from "hooks/useApp";

const SubscribeNow = () => {
  const { track } = useApp();

  return (
    <Flex flexDir="column" gap="1rem">
      <Text
        fontSize="14px"
        fontWeight="bold"
        textAlign={{
          base: "left",
          xl: "center",
        }}
      >
        Everything about BNBx
      </Text>
      <Button
        variant="outline"
        borderColor="brand.textColor"
        color="brand.textColor"
        _hover={{
          bg: "brand.primary",
        }}
        _dark={{
          _hover: {
            color: "black",
            borderColor: "black",
          },
        }}
        as="a"
        href={LEARN_MORE_URL}
        target="_blank"
        onClick={() => track(LEARN_MORE)}
      >
        <Text fontSize="14px" fontFamily="semi-bold">
          Learn more
        </Text>
      </Button>
    </Flex>
  );
};

export default SubscribeNow;
